<!--
 * @Auther: 罗耀祖
 * @Date: 2021-09-17 11:23:26
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-27 17:18:52
 * @name: 工作流管理
 * @Description: 工作流管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalManage\flowManage.vue
 * @Author: desktop
-->
<template>
  <layout-normal>
    <table-normal>
      <template v-slot:title>
        <div class="title">工作流列表</div>
      </template>
      <template v-slot:table>
        <el-table
          :data="list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="id" label="ID" width="150">
          </el-table-column>
          <el-table-column align="center" prop="flow_name" label="名称">
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="design(scope.row)"
                >设计</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </table-normal>
  </layout-normal>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";
import flow from "@/object/flow/flow.class.js";
import { debounceation } from "@/utils/decorator";
export default {
  name: "flowManage",
  components: {
    tableNormal,
  },
  data() {
    return {
      flow: new flow(),
      list: [],
      loading: false,
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取工作流列表
     */
    getList() {
      this.loading = true;
      this.flow
        .workflowGetList()
        .then((res) => {
          this.list = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 跳转设计
     * @param {Object} row 列表行数据
     */
    @debounceation(300)
    design(row) {
      this.$router.push({
        name: "flowManageDesign",
        query: { flow_id: row.id },
      });
    },
  },
};
</script>